import { useState } from 'react'
import { apiEtapa2 } from '../api'
import Aviso from '../../components/Aviso'
import { moeda } from '../../components/format'
import { Campo, Cards, Gravado, Recibo, dataBR, listaValores } from '../componentes'

export default function DecimoTerceiro({ empresaId }) {
  const [parcela, setParcela] = useState(1)
  const [f, setF] = useState({
    funcionario_id: 'F1', nome: '', dependentes_irrf: 0, salario: '', data_pagamento: '',
    data_admissao: '', avos: '', valor_adiantamento: '',
  })
  const [variaveis, setVariaveis] = useState('')
  const [res, setRes] = useState(null)
  const [erro, setErro] = useState('')
  const [carregando, setCarregando] = useState(false)
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value })

  async function calcular(gravar) {
    setErro('')
    setCarregando(true)
    const base = { empresa_id: empresaId, funcionario_id: f.funcionario_id, nome: f.nome, dependentes_irrf: Number(f.dependentes_irrf) || 0, data_pagamento: f.data_pagamento }
    try {
      if (parcela === 1) {
        setRes({ parcela: 1, ...(await apiEtapa2.primeiraParcela({ ...base, salario_mes_anterior: f.salario }, gravar)) })
      } else {
        const entrada = {
          ...base,
          salario_base: f.salario,
          variaveis_ano: listaValores(variaveis),
          data_admissao: f.data_admissao || null,
          avos: f.avos === '' ? null : Number(f.avos),
          valor_adiantamento: f.valor_adiantamento === '' ? null : f.valor_adiantamento,
        }
        setRes({ parcela: 2, ...(await apiEtapa2.segundaParcela(entrada, gravar)) })
      }
    } catch (e) {
      setErro(e.message)
      setRes(null)
    } finally {
      setCarregando(false)
    }
  }

  const r = res?.resultado
  return (
    <section>
      <h2>13º salário</h2>
      <nav>
        {[1, 2].map((p) => (
          <button key={p} className={parcela === p ? 'ativa' : ''} onClick={() => { setParcela(p); setRes(null) }}>
            {p === 1 ? '1ª parcela (adiantamento)' : '2ª parcela (quitação)'}
          </button>
        ))}
      </nav>
      <div className="grade">
        <Campo rotulo="Matrícula"><input value={f.funcionario_id} onChange={set('funcionario_id')} /></Campo>
        <Campo rotulo="Nome"><input value={f.nome} onChange={set('nome')} /></Campo>
        <Campo rotulo={parcela === 1 ? 'Salário do mês anterior' : 'Salário de dezembro'}>
          <input type="number" step="0.01" value={f.salario} onChange={set('salario')} />
        </Campo>
        <Campo rotulo="Data de pagamento"><input type="date" value={f.data_pagamento} onChange={set('data_pagamento')} /></Campo>
        {parcela === 2 && (
          <>
            <Campo rotulo="Dependentes IRRF"><input type="number" min="0" value={f.dependentes_irrf} onChange={set('dependentes_irrf')} /></Campo>
            <Campo rotulo="Admissão (se no ano)"><input type="date" value={f.data_admissao} onChange={set('data_admissao')} /></Campo>
            <Campo rotulo="Avos (opcional)"><input type="number" min="0" max="12" value={f.avos} onChange={set('avos')} /></Campo>
            <Campo rotulo="Adiantamento pago"><input type="number" step="0.01" value={f.valor_adiantamento} placeholder="busca a 1ª parcela gravada" onChange={set('valor_adiantamento')} /></Campo>
          </>
        )}
      </div>
      {parcela === 2 && (
        <Campo rotulo="Variáveis de cada mês do ano (separadas por ponto e vírgula)">
          <input value={variaveis} onChange={(e) => setVariaveis(e.target.value)} placeholder="350,00; 420,50; ..." />
        </Campo>
      )}
      <p className="fundamento">
        {parcela === 1
          ? '50% do salário do mês anterior, pago entre 01/02 e 30/11. Sem INSS e IRRF; incide apenas FGTS.'
          : 'Pago até 20/12. INSS e IRRF calculados de forma exclusiva, separados da folha mensal. Desconta o valor bruto da 1ª parcela.'}
      </p>
      <div className="acoes">
        <button disabled={carregando || !empresaId} onClick={() => calcular(false)}>Calcular</button>
        <button className="secundario" disabled={carregando || !empresaId} onClick={() => calcular(true)}>Calcular e gravar</button>
      </div>
      <Aviso>{erro}</Aviso>
      {r && res.parcela === 1 && (
        <>
          <Gravado registroId={res.registro_id} />
          <Cards itens={[['Valor da 1ª parcela', moeda(r.valor_bruto), `Pagamento em ${dataBR(r.data_pagamento)}`], ['INSS / IRRF', moeda(0), 'Sem retenção'], ['FGTS', moeda(r.fgts)]]} />
          <ul className="memoria">{r.memoria_calculo.map((m) => <li key={m}>{m}</li>)}</ul>
        </>
      )}
      {r && res.parcela === 2 && (
        <>
          <Gravado registroId={res.registro_id} />
          <Cards
            itens={[
              ['13º integral', moeda(r.valor_integral), `${r.avos}/12 avos · média ${moeda(r.media_variaveis)}`],
              ['Adiantamento descontado', moeda(r.adiantamento_descontado)],
              ['Líquido da 2ª parcela', moeda(r.liquido)],
            ]}
          />
          <Recibo titulo={`13º salário ${r.ano} · 2ª parcela`} resultado={r} />
        </>
      )}
    </section>
  )
}
